import i18n from '@/plugins/i18n';

export const config = {
  VIEW_TYPE: {
    INSTALLED: 'INSTALLED',
    AVAILABLE: 'AVAILABLE',
  },
  INSTALL_WINDOW: {
    GCP: {
      icon: 'gcp.png',
      title: i18n.global.t('google-cloud-platform-integration'),
      subtitle: i18n.global.t(
        'suite-of-cloud-computing-services-provided-by-google',
      ),
      desc: i18n.global.t(
        'installing-the-google-cloud-platform-integration-could-increase-the-number-of-servers-that-sixthsense-observability-monitors-for-more-information-on-how-this-may-affect-your-billing-visit-the-billing-faq-page',
      ),
    },
    AWS: {
      icon: 'aws.png',
      title: i18n.global.t('amazon-webservice-integration'),
      subtitle: i18n.global.t(
        'suite-of-cloud-computing-services-provided-by-google',
      ),
      desc: i18n.global.t(
        'installing-the-google-cloud-platform-integration-could-increase-the-number-of-servers-that-sixthsense-observability-monitors-for-more-information-on-how-this-may-affect-your-billing-visit-the-billing-faq-page',
      ),
    },
    AZURE: {
      icon: 'azure.png',
      title: i18n.global.t('microsoft-azure-integration'),
      subtitle: i18n.global.t(
        'suite-of-cloud-computing-services-provided-by-google',
      ),
      desc: i18n.global.t(
        'installing-the-google-cloud-platform-integration-could-increase-the-number-of-servers-that-sixthsense-observability-monitors-for-more-information-on-how-this-may-affect-your-billing-visit-the-billing-faq-page',
      ),
    },
  },
  MESSAGES: {
    UPATE_PROJECT: {
      SUCCESS: i18n.global.t('project-updated'),
      ERROR: i18n.global.t('an-error-occured-while-updating-project'),
    },
    ADD_PROJECT: {
      SUCCESS: i18n.global.t('project-added'),
      ERROR: i18n.global.t('an-error-occured-while-uploading-project'),
    },
    UNINSTALL_INTEGRATION: {
      SUCCESS: i18n.global.t('integration-uninstalled'),
      ERROR: i18n.global.t('an-error-occured-while-uninstalling-integration'),
    },
  },
};
